import {
  ConnectedDevices as ApiConnectedDevices,
  StatisticMessage as ApiStatisticMessage
} from '@infuse/api/e-connector/statistics';
import { EconnectorStatistics } from './model';
import { enumFromStringValue } from '@infuse/utils';
import { MessageType } from '@infuse/e-connector/message/domain';

export const mapToDomain = (
  messages: ApiStatisticMessage[],
  totalMessages: number,
  connectedDevices: ApiConnectedDevices
): EconnectorStatistics => {
  return {
    totalMessages: totalMessages || 0,
    centralSystems: connectedDevices?.centralSystems ?? { connected: 0, total: 0 },
    chargingStations: connectedDevices?.chargePoints ?? { connected: 0, total: 0 },
    messageStatsLast5Hours: Array.isArray(messages)
      ? messages.map((m) => {
          return {
            date: new Date(m.date),
            messageType: enumFromStringValue(MessageType, m.messageType),
            count: m.count
          };
        })
      : []
  } as EconnectorStatistics;
};
